import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface Tab {
  id: string;
  label: string;
  path: string;
  permission?: string;
}

interface CallLogsTabsProps {
  className?: string;
  checkPermission?: (url: string) => boolean;
  callAPIUrls?: {
    getExportCallLogs?: string;
    getCallLogsAnalytics?: string;
  };
}

const CallLogsTabs: React.FC<CallLogsTabsProps> = ({ 
  className = '', 
  checkPermission,
  callAPIUrls 
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs: Tab[] = [
    {
      id: 'call-logs',
      label: 'Call Logs',
      path: '/call-logs'
    },
    {
      id: 'call-logs-analytics',
      label: 'Call Logs Analytics',
      path: '/call-logs-analytics',
      permission: callAPIUrls?.getCallLogsAnalytics || 'call-logs-analytics'
    }
  ];

  // Filter tabs based on permissions
  const visibleTabs = tabs.filter(tab => {
    if (tab.permission && checkPermission) {
      return checkPermission(tab.permission);
    }
    return true;
  });

  const activeTab = visibleTabs.find(tab => location.pathname === tab.path)?.id || 'call-logs';

  const handleTabClick = (path: string) => {
    navigate(path);
  };

  const handleExport = () => {
    // Add your export logic here
    console.log('Exporting call logs...');
  };

  return (
    <div className={`border-b border-gray-200 ${className}`}>
      <div className="flex justify-between items-center">
        <nav className="-mb-px flex space-x-8">
          {visibleTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.path)}
              className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                activeTab === tab.id
                  ? 'border-[#233580fc] text-[#233580fc]'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
        

     
      </div>
    </div>
  );
};

export default CallLogsTabs;